import { useLocalPagePaginatedTrendingPetitionsData } from 'src/app/pages/local/pageContext';

type Result = ModelHookResult<{
	indexed: boolean;
}>;

export function useMetaRobots(): Result {
	const {
		data: { totalCount },
	} = useLocalPagePaginatedTrendingPetitionsData();

	return {
		data: {
			indexed: !!totalCount,
		},
	};
}
